exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* 统一组件中的特殊组件 */\n[data-v-f5444fc4] .el-dialog__header {\n  display: none !important;\n}\n[data-v-f5444fc4] .el-dialog__body {\n  padding: 2px 20px 0 20px !important;\n}\n.selfDialogClose[data-v-f5444fc4] {\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 3px;\n  pointer-events: auto;\n  z-index: 999;\n  font-size: 20px;\n  color: #363f4d;\n}\n", ""]);

// exports
